export const LIST_AI_WORKLOADS = `
  query ListAIWorkloads($element4Map: String) {
    listAIWorkloads(element4Map: $element4Map) {
      workloadId
      workloadType
      element1
      element2
      element3
      element4
      iamRoleArn
      estimateType
      estimateDollar
      estimateInputTokens
      estimateOutputTokens
      estimateCacheReadTokens
      estimateSetAt
      estimateSetBy
      aiComponents
      claimedAt
      claimedBy
    }
  }
`
